import React from 'react';



export default function NoAccess() {
    return <div>
        <h2>Page restricted or does not exist</h2>
    </div>;
}